import { BadgeTypes } from 'dash-ui';
import {
  AccountPhoneNumberStatusesEnum,
  BrokerLicenseStatusesEnum,
  ProductSubscriptionStatusesEnum,
} from 'dash-common';

export const SUBSCRIPTION_STATUSES_STYLES: Record<string, BadgeTypes> = {
  [ProductSubscriptionStatusesEnum.ACTIVE]: 'active',
  [ProductSubscriptionStatusesEnum.CANCELED]: 'danger',
  [ProductSubscriptionStatusesEnum.INCOMPLETE]: 'danger',
  [ProductSubscriptionStatusesEnum.INCOMPLETE_EXPIRED]: 'danger',
  [ProductSubscriptionStatusesEnum.PAST_DUE]: 'warning',
  [ProductSubscriptionStatusesEnum.SCHEDULED_CANCELLATION]: 'warning',
  [ProductSubscriptionStatusesEnum.TRIALING]: 'neutral',
  [ProductSubscriptionStatusesEnum.UNPAID]: 'danger',
};

export const PHONE_NUMBER_STATUSES_STYLES: Record<string, BadgeTypes> = {
  [AccountPhoneNumberStatusesEnum.VERIFIED]: 'active',
  [AccountPhoneNumberStatusesEnum.NOT_VERIFIED]: 'danger',
};

export const BROKER_LICENSE_STATUSES_STYLES: Record<string, BadgeTypes> = {
  [BrokerLicenseStatusesEnum.ACTIVE]: 'active',
  [BrokerLicenseStatusesEnum.INACTIVE]: 'danger',
  [BrokerLicenseStatusesEnum.PENDING_REVIEW]: 'warning',
};
